import { Auth0SecuredApp } from './Auth0SecureApp'

const OktaAndAuth0SecureApp = () => {
  // NewRelic user tracking removed - add your new analytics service here if needed
  return <Auth0SecuredApp />
}

export default OktaAndAuth0SecureApp
